import Reveal from "@/components/base/Reveal";

export default function ClinicOverview() {
  return (
    <section className="w-full bg-background-50 px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-3xl mx-auto">
        <Reveal>
          <div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold leading-tight text-foreground-950">
              About Florida Family Clinic
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-foreground-600">
              <p>
                Florida Family Clinic is a private medical practice serving patients in Miami,
                Florida. The clinic offers orthopedic care, pain-related services, diagnostic
                testing, and medically supervised wellness support.
              </p>
              <p>
                Care is provided in an outpatient setting, which means visits are planned and
                completed without an overnight stay. This approach keeps the experience simple and
                focused on the individual patient's needs.
              </p>
              <p>
                The clinic's services are intended to support general health and musculoskeletal
                needs through evaluation, appropriate diagnostics, and treatment options discussed
                directly with each patient.
              </p>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <span className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold">
                <i className="ri-map-pin-line" />
                Miami, Florida
              </span>
              <span className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-accent-50 text-accent-700 text-xs font-semibold">
                <i className="ri-hospital-line" />
                Outpatient setting
              </span>
              <span className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold">
                <i className="ri-user-heart-line" />
                Private practice
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}